// How modifier keys are *named* in user-facing copy — key handling itself lives
// in useShortcut. The gesture never differs by platform (`event.altKey` is set by
// Option on a Mac and by Alt everywhere else), but a hint that names a key the
// user cannot find on their keyboard is worse than no hint, and US-layout Mac
// keyboards print only "option".
//
// A label only belongs here if it needs no translation. Cmd/Ctrl does not
// qualify: ⌘ is universal, but its counterpart is "Ctrl" in English and "Strg"
// in German, so that pair needs an i18n key rather than a constant.

// Deliberately evaluated once: the platform cannot change mid-session.
// `navigator.platform` is deprecated but remains the broadest signal;
// `userAgentData.platform` exists only in Chromium, so it can't stand alone.
export const IS_APPLE = /mac|iphone|ipad|ipod/i.test(
	globalThis.navigator?.platform || globalThis.navigator?.userAgent || "",
);

/**
 * Interpolate into copy as `{key}`. The symbol is used rather than the word
 * "Option" because ⌥ is printed on every Mac keyboard regardless of layout or
 * language, so this needs no per-locale variant — as the spelled-out word would.
 */
export const ALT_KEY_LABEL = IS_APPLE ? "⌥" : "Alt";

/**
 * Cmd/Ctrl as a chord's prefix: `${modKeyLabel(…)}B` reads "⌘B" or "Ctrl+B". The separator
 * rides along because only the non-Apple side takes one. Takes the translated word rather
 * than calling `t()` — per the note above, Ctrl is "Strg" in German.
 */
export function modKeyLabel(ctrlWord: string): string {
	return IS_APPLE ? "⌘" : `${ctrlWord}+`;
}
